<template>
    <div class="apprentice-simple-card">
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('common.title') }}</label>
            <div class="col-sm-9">
                <b-form-input
                    class="apprentice-input-field"
                    v-model="title"
                    type="text"
                    name="title"
                    :placeholder="$t('common.title')"></b-form-input>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.active_for_print') }}:</label>
            <div class="col-sm-9">
                <design-2021-apprentice-multiselect-component
                    v-model="selected_active_for_print"
                    label="name"
                    :options="yesOrNo"
                    :show-labels="false"
                    :selected-in="selected_active_for_print"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">CJP actie:</label>
            <div class="col-sm-9">
                <design-2021-apprentice-multiselect-component
                    v-model="selected_cjp_promotional"
                    label="name"
                    :options="yesOrNo"
                    :show-labels="false"
                    :selected-in="selected_cjp_promotional"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.edition') }}</label>
            <div class="col-sm-9">
                <b-form-input
                    class="apprentice-input-field"
                    v-model="quantity"
                    type="number"
                    name="quantity"></b-form-input>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.editors_see_all_pages') }}</label>
            <div class="col-sm-9">
                <design-2021-apprentice-multiselect-component
                    v-model="selected_show_all_pages"
                    label="name"
                    :options="yesOrNo"
                    :show-labels="false"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazines.own_images_templates') }}</label>
            <div class="col-sm-9">
                <design-2021-apprentice-multiselect-component
                    v-model="selected_own_templates"
                    label="name"
                    :options="yesOrNo"
                    :show-labels="false"
                    :selected-in="selected_own_templates"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.page_format') }}</label>
            <div class="col-sm-9">
                <design-2021-apprentice-multiselect-component
                    v-model="selected_size"
                    label="title"
                    :options="sizesIn"
                    :show-labels="false"
                    :selected-in="selected_size"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.format_type') }}</label>
            <div class="col-sm-9">
                <design-2021-apprentice-multiselect-component
                    v-model="selected_version"
                    label="name"
                    :options="versionsIn"
                    :show-labels="false"
                    :selected-in="selected_version"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.lamination') }}</label>
            <div class="col-sm-9">
                <div v-if="laminationError">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('magazine.lamination_mandatory') }}
                    </b-alert>
                </div>
                <design-2021-apprentice-multiselect-component
                    v-model="selected_lamination"
                    label="name"
                    :options="laminationsIn"
                    :show-labels="false"
                    :selected-in="selected_lamination"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.create_the_cover_entirely') }}</label>
            <div class="col-sm-9">
                <design-2021-apprentice-multiselect-component
                    v-model="selected_full_cover"
                    label="name"
                    :options="yesOrNo"
                    :show-labels="false"
                    :selected-in="selected_full_cover"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.paper') }}</label>
            <div class="col-sm-9">
                <div v-if="paperError">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('magazine.paper_mandatory') }}
                    </b-alert>
                </div>
                <design-2021-apprentice-multiselect-component
                    v-model="selected_paper"
                    label="name"
                    :options="papersIn"
                    :show-labels="false"
                    :selected-in="selected_paper"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.printer') }}</label>
            <div class="col-sm-9">
                <div v-if="printerError">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('magazine.printer_mandatory') }}
                    </b-alert>
                </div>
                <design-2021-apprentice-multiselect-component
                    v-model="selected_printer"
                    label="name"
                    :options="printersIn"
                    :show-labels="false"
                    :selected-in="selected_printer"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.margin_top') }}</label>
            <div class="col-sm-9">
                <b-form-input
                    class="apprentice-input-field"
                    v-model="marginTop"
                    type="number"
                    name="margin_top"></b-form-input>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.margin_right') }}</label>
            <div class="col-sm-9">
                <b-form-input
                    class="apprentice-input-field"
                    v-model="marginRight"
                    type="number"
                    name="margin_right"></b-form-input>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.margin_bottom') }}</label>
            <div class="col-sm-9">
                <b-form-input
                    class="apprentice-input-field"
                    v-model="marginBottom"
                    type="number"
                    name="margin_bottom"></b-form-input>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.margin_left') }}</label>
            <div class="col-sm-9">
                <b-form-input
                    class="apprentice-input-field"
                    v-model="marginLeft"
                    type="number"
                    name="margin_left"></b-form-input>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.comments') }}</label>
            <div class="col-sm-9">
                <b-form-textarea
                    class="apprentice-textarea"
                    id="textarea"
                    v-model="remarks"
                    rows="5"
                    name="remarks"></b-form-textarea>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.to_archive') }}</label>
            <div class="col-sm-9">
                <design-2021-apprentice-multiselect-component
                    v-model="selected_archived"
                    label="name"
                    :options="yesOrNo"
                    :show-labels="false"
                    :selected-in="selected_archived"
                    :multiple-select="false">
                </design-2021-apprentice-multiselect-component>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.distribution_date') }}</label>
            <div class="col-sm-9">
                <b-form-datepicker
                    class="apprentice-date-picker"
                    id="reach_out_date-input"
                    v-model="reach_out_date"
                    start-weekday="1"
                    now-button
                    reset-button
                    right
                    today-variant="primary"
                    nav-button-variant="primary"
                    locale="nl"
                    :aria-controls="$t('magazine.choose_a_date')"
                    label-reset-button="reset"
                    :label-no-date-selected="$t('magazine.choose_a_date')"
                    menu-class="datedropdown"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }">
                </b-form-datepicker>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label">{{ $t('magazine.delivery_address') }}</label>
            <div class="col-sm-9">
                <div v-if="cityError">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('magazine.place_mandatory') }}
                    </b-alert>
                </div>
                <b-form-input
                    class="apprentice-input-field"
                    v-model="city"
                    type="text"
                    name="city"
                    :placeholder="$t('common.city')"></b-form-input>

                <div v-if="streetError">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('magazine.street_name_mandatory') }}
                    </b-alert>
                </div>
                <b-form-input
                    class="apprentice-input-field"
                    v-model="street"
                    type="text"
                    name="street"
                    :placeholder="$t('magazine.street_name')"></b-form-input>

                <div v-if="streetnumberError">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('magazine.house_number_mandatory') }}
                    </b-alert>
                </div>
                <b-form-input
                    class="apprentice-input-field"
                    v-model="streetnumber"
                    type="text"
                    name="streetnumber"
                    :placeholder="$t('common.house_number')"></b-form-input>

                <div v-if="zipcodeError">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('magazine.postal_code_mandatory') }}
                    </b-alert>
                </div>
                <b-form-input
                    class="apprentice-input-field"
                    v-model="zipcode"
                    type="text"
                    name="zipcode"
                    :placeholder="$t('common.postal_code')"></b-form-input>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-3 col-form-label"></label>
            <div class="col-sm-9">
                <button
                    class="btn btn-save btn-primary mr-2"
                    @click="save">
                    {{ $t('common.save') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-settings-component',
    props: {
        magazineIn: {
            type: Object,
        },
        sizesIn: {
            type: Array,
        },
        versionsIn: {
            type: Array,
        },
        laminationsIn: {
            type: Array,
        },
        papersIn: {
            type: Array,
        },
        printersIn: {
            type: Array,
        },
    },
    data() {
        return {
            title: this.magazineIn.title,
            quantity: this.magazineIn.quantity,
            marginTop: this.magazineIn.margin_top,
            marginBottom: this.magazineIn.margin_bottom,
            marginLeft: this.magazineIn.margin_left,
            marginRight: this.magazineIn.margin_right,
            reach_out_date: this.magazineIn.reach_out_date,
            remarks: this.magazineIn.remarks,
            city: this.magazineIn.city,
            street: this.magazineIn.street,
            streetnumber: this.magazineIn.streetnumber,
            zipcode: this.magazineIn.zipcode,
            activeforprint: this.magazineIn.activeforprint,
            cjp_promotional: this.magazineIn.cjp_promotional,
            selected_size: this.selectedSize(),
            selected_version: this.selectedVersion(),
            selected_lamination: this.selectedLamination(),
            selected_paper: this.selectedPaper(),
            selected_printer: this.selectedPrinter(),
            selected_show_all_pages: this.selectedYesOrNo(this.magazineIn.show_all_pages),
            selected_own_templates: this.selectedYesOrNo(this.magazineIn.own_templates),
            selected_full_cover: this.selectedYesOrNo(this.magazineIn.full_cover),
            selected_active_for_print: this.selectedYesOrNo(this.magazineIn.activeforprint),
            selected_cjp_promotional: this.selectedYesOrNo(this.magazineIn.cjp_promotional),
            yesOrNo: [
                { value: 1, name: this.$t('common.yes') },
                { value: 0, name: this.$t('common.no') },
            ],
            selected_archived: this.selectedYesOrNo(this.magazineIn.archived),

            cityError: false,
            streetError: false,
            streetnumberError: false,
            zipcodeError: false,
            laminationError: false,
            paperError: false,
            printerError: false,
        };
    },
    methods: {
        save() {
            this.cityError = false;
            this.streetError = false;
            this.streetnumberError = false;
            this.zipcodeError = false;
            this.laminationError = false;
            this.paperError = false;
            this.printerError = false;

            if (!this.selected_lamination) {
                this.laminationError = true;
            }

            if (!this.selected_paper) {
                this.paperError = true;
            }

            if (!this.selected_printer) {
                this.printerError = true;
            }

            if (this.city || this.streetnumber || this.street || this.zipcode) {
                this.cityError = !this.city;
                this.streetnumberError = !this.streetnumber;
                this.streetError = !this.street;
                this.zipcodeError = !this.zipcode;
            } else {
                this.cityError = false;
                this.streetnumberError = false;
                this.streetError = false;
                this.zipcodeError = false;
            }

            if (
                !this.cityError &&
                !this.streetnumberError &&
                !this.streetError &&
                !this.zipcodeError &&
                !this.laminationError &&
                !this.paperError &&
                !this.printerError
            ) {
                this.alert.saving();

                let data = {
                    title: this.title,
                    quantity: this.quantity,
                    show_all_pages: this.selected_show_all_pages.value,
                    own_templates: this.selected_own_templates.value,
                    size: this.selected_size.id,
                    version: this.selected_version.id,
                    lamination: this.selected_lamination.id,
                    full_cover: this.selected_full_cover.value,
                    paper: this.selected_paper.id,
                    printer: this.selected_printer.id,
                    margin_top: this.marginTop,
                    margin_right: this.marginRight,
                    margin_bottom: this.marginBottom,
                    margin_left: this.marginLeft,
                    remarks: this.remarks,
                    archived: this.selected_archived.value,
                    city: this.city,
                    street: this.street,
                    streetnumber: this.streetnumber,
                    zipcode: this.zipcode,
                    reach_out_date: this.reach_out_date,
                    activeforprint: this.selected_active_for_print.value,
                    cjp_promotional: this.selected_cjp_promotional.value,
                };

                this.axios.post(this.routes.magazineSettings(this.magazineIn.id), data).then(
                    (response) => {
                        this.alert.success();

                        window.location.href = this.routes.magazine(this.magazineIn.id);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },

        selectedSize() {
            for (let size of this.sizesIn) {
                if (this.magazineIn.size_id === size.id) {
                    return size;
                }
            }
        },

        selectedVersion() {
            for (let version of this.versionsIn) {
                if (this.magazineIn.version === version.id) {
                    return version;
                }
            }
        },

        selectedLamination() {
            for (let lamination of this.laminationsIn) {
                if (this.magazineIn.lamination === lamination.id) {
                    return lamination;
                }
            }
        },

        selectedPaper() {
            for (let paper of this.papersIn) {
                if (this.magazineIn.paper === paper.id) {
                    return paper;
                }
            }
        },

        selectedPrinter() {
            for (let printer of this.printersIn) {
                if (this.magazineIn.printer === printer.id) {
                    return printer;
                }
            }
        },

        selectedYesOrNo(answer) {
            if (answer === 1) {
                return { value: 1, name: this.$t('common.yes') };
            } else {
                return { value: 0, name: this.$t('common.no') };
            }
        },
    },
    mounted() {
        console.log(this.magazineIn);
    },
};
</script>

<style scoped></style>
